export function invoiceFormatLabel(fmt: string): string {
  return fmt.replace(/^\./, '').toUpperCase();
}
